// src/components/ErrorBoundary/ErrorBoundaryWrapper.jsx
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

const ErrorBoundaryWrapper = ({ children, componentName, onError }) => {
  const handleError = (error, errorInfo) => {
    console.error(`Error in ${componentName || 'component'}:`, error, errorInfo);
    

    if (onError) {
      onError(error, errorInfo);
    }
  };

  const handleReset = () => {
  };

  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <ErrorFallback
          error={error}
          resetErrorBoundary={() => {
            handleReset();
            resetErrorBoundary();
          }}
          componentName={componentName}
        />
      )}
      onError={handleError}
      onReset={handleReset}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;